import { MaintenanceWindowManuallyApprovedPatchesSelectorBaseDataProvider } from './MaintenanceWindowManuallyApprovedPatchesSelectorBaseDataProvider';
import { ManuallyApprovedPatch } from '../types';
import { sanitizeObject } from '../../../utils/sanitization.utils';

export class MaintenanceWindowManuallyApprovedPatchesSelectorGzDataProvider extends MaintenanceWindowManuallyApprovedPatchesSelectorBaseDataProvider {
  public async getManuallyApprovedPatchesForCompany(companyId: string): Promise<ManuallyApprovedPatch[]> {
    try {
      const result = await this.dependencies.api.clients.PatchesCatalog.getManuallyApprovedPatchesForCompany(companyId);

      if (!result || !result.success) {
        return [];
      }

      return sanitizeObject(result.data);
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}
